"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultContractNetworks = void 0;
exports.defaultContractNetworks = {
    // mainnet
    1: {
        multiSendAddress: '0x8D29bE29923b68abfDD21e541b9374737B49cdAD',
        safeMasterCopyAddress: '0x6851D6fDFAfD08c0295C392436245E5bc78B0185',
        safeProxyFactoryAddress: '0x76E2cFc1F5Fa8F6a5b3fC4c8F4788F0116861F9B'
    },
    // rinkeby
    4: {
        multiSendAddress: '0x8D29bE29923b68abfDD21e541b9374737B49cdAD',
        safeMasterCopyAddress: '0x6851D6fDFAfD08c0295C392436245E5bc78B0185',
        safeProxyFactoryAddress: '0x76E2cFc1F5Fa8F6a5b3fC4c8F4788F0116861F9B'
    },
    // goerli
    5: {
        multiSendAddress: '0x8D29bE29923b68abfDD21e541b9374737B49cdAD',
        safeMasterCopyAddress: '0x6851D6fDFAfD08c0295C392436245E5bc78B0185',
        safeProxyFactoryAddress: '0x76E2cFc1F5Fa8F6a5b3fC4c8F4788F0116861F9B'
    },
    // kovan
    42: {
        multiSendAddress: '0x8D29bE29923b68abfDD21e541b9374737B49cdAD',
        safeMasterCopyAddress: '0x6851D6fDFAfD08c0295C392436245E5bc78B0185',
        safeProxyFactoryAddress: '0x76E2cFc1F5Fa8F6a5b3fC4c8F4788F0116861F9B'
    },
    // xdai
    100: {
        multiSendAddress: '0x8D29bE29923b68abfDD21e541b9374737B49cdAD',
        safeMasterCopyAddress: '0x6851D6fDFAfD08c0295C392436245E5bc78B0185',
        safeProxyFactoryAddress: '0x76E2cFc1F5Fa8F6a5b3fC4c8F4788F0116861F9B'
    },
    // energy web chain
    246: {
        multiSendAddress: '0x8D29bE29923b68abfDD21e541b9374737B49cdAD',
        safeMasterCopyAddress: '0x6851D6fDFAfD08c0295C392436245E5bc78B0185',
        safeProxyFactoryAddress: '0x76E2cFc1F5Fa8F6a5b3fC4c8F4788F0116861F9B'
    },
    // energy web volta
    73799: {
        multiSendAddress: '0x8D29bE29923b68abfDD21e541b9374737B49cdAD',
        safeMasterCopyAddress: '0x6851D6fDFAfD08c0295C392436245E5bc78B0185',
        safeProxyFactoryAddress: '0x76E2cFc1F5Fa8F6a5b3fC4c8F4788F0116861F9B'
    }
};
//# sourceMappingURL=contracts.js.map